const productCardFactory = require('../shelfproduct/shelfbundle-card-factory');
const searchMapper = require('./atm/search-mapper');

module.exports = function (searchService, $state, settingsService, atm) {
    return {
        restrict: 'E',
        require: '^wowCardList',
        scope: {},
        link(scope, element, attrs, cardListCtrl) {

            function createCards(result) {
                if (!result) {
                    return;
                }

                // the result items order preference and relevancies are being changed in the transformProductsToDefault
                // so the same reference should be used in createProductCards
                const resultItems = result && result.items || [];
                const ads = result && result.ads || [];
                const total = result && result.totalRecordCount || 0;
                const defaultProducts = searchService.transformProductsToDefault(resultItems, null, ads);
                //For redirect pages there will not be any result
                const isRedirectPage = (result) ? false : true;

                return {
                    items: productCardFactory.createProductCards(defaultProducts, resultItems),
                    totalRecordCount: total,
                    productCollection: resultItems,
                    isRedirect: isRedirectPage,
                    eventId: result.eventId,
                    featureTiles: result.featureTiles
                };
            }

            function updateAnalytics(result) {
                const resultPidList = result && result.items && result.items.length && result.items.map(item => item.data.product.Stockcode);
                const pidList = resultPidList && resultPidList.length ? resultPidList : null;
                const atmData = {
                    area: 'header',
                    keyword: $state.params.searchTerm,
                    searchCount: (result && result.isRedirect ? 'redirect' : result.totalRecordCount),
                    searchType: 'keyword',
                    category: {},
                    product: { pid_list: pidList },
                    eventId: result.eventId
                };
                atm.push(atmData, searchMapper);
            }

            // Product provider function
            function getCards(pageSize, pageNumber, isSpecial, filter, banner) {
                return settingsService.getSettingValue('Search', 'SortOptions')
                    .then(function (response) {
                        return response[0].Value;
                    }).then(function (sortBySetting) {
                        return searchService.doSearch(
                            $state.params.searchTerm,
                            pageSize,
                            pageNumber,
                            ($state.params.sortby || sortBySetting),
                            isSpecial,
                            filter,
                            banner)
                            .then(createCards)
                            .then((result) => {
                                if (pageNumber === 1 && result) {
                                    updateAnalytics(result);
                                }
                                return result;
                            });
                    });
            }

            function updateProducts() {
                cardListCtrl.update();
            }

            cardListCtrl.setOptions({
                getCards,
                zeroCardsTemplate: '<wow-search-zero-results></wow-search-zero-results>',
                getTitle: () => $state.params.searchTerm,
                updateCardsOnLogin: true
            });

            scope.$watch(function () { return $state.params.searchTerm; }, updateProducts);

            scope.$on('address-update', function () {
                searchService.resetPrevious();
                updateProducts();
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/search/search-list-directive.js
 **/